<template>
    <main class="cart default">
        <div class="container text-center">
            <div class="cart-empty">
                <div class="cart-empty-icon">
                    <i class="now-ui-icons shopping_basket"></i>
                </div>
                <div class="cart-empty-title">سبد خرید شما خالیست!</div>
                <div class="parent-btn" v-if="!isUserLogined">
                    <router-link to="/login" class="dk-btn dk-btn-success">
                        به حساب کاربری خود وارد شوید
                        <i class="fa fa-sign-in"></i>
                    </router-link>    
                </div>
                <div class="cart-empty-url" v-if="!isUserLogined">
                    <span>کاربر جدید هستید؟</span>
                    <router-link to="/register">ثبت‌نام </router-link>
                </div>
            </div>
        </div>
    </main>
</template>

<script>

    export default {
        data() {
            return {
                isUserLogined: false
            }
        },
        computed: {

        }, 
        beforeMount() {
          
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        }
    }
</script>

<style scoped>
</style>